import React from 'react';
import { ProjectRequestField } from '../../../services/formFeedsApi';

interface MappingRowProps {
  projectField: ProjectRequestField;
  formFields: Array<{ name: string; label: string; type: string }>;
  selectedFormField: string;
  onMappingChange: (projectFieldKey: string, formFieldName: string) => void;
}

const MappingRow: React.FC<MappingRowProps> = ({
  projectField,
  formFields,
  selectedFormField,
  onMappingChange,
}) => {
  const isMapped = selectedFormField !== '';

  return (
    <tr className={`theme-bg-primary hover:theme-bg-tertiary transition-colors ${isMapped ? 'border-l-4 border-l-blue-500' : ''}`}>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="flex-1">
            <p className="text-sm font-medium theme-text-primary">{projectField.label}</p>
            <p className="text-xs theme-text-tertiary mt-0.5">{projectField.key}</p>
          </div>
          {isMapped && (
            <span className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full"></span>
          )}
        </div>
      </td>
      <td className="px-4 py-3">
        <select
          value={selectedFormField}
          onChange={(e) => onMappingChange(projectField.key, e.target.value)}
          className="w-full px-3 py-2 rounded-lg theme-bg-tertiary theme-border border theme-text-primary focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
        >
          <option value="">-- Select Form Field --</option>
          {formFields.map((formField) => (
            <option key={formField.name} value={formField.name}>
              {formField.label} ({formField.name})
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
};

export default MappingRow;
